class GlobalGeneric {
  static addCurrentParams(path, newParams) {
    const url = new URL(path, window.location.origin);

    const currentParams = new URLSearchParams(window.location.search);
    currentParams.forEach((value, key) => {
      url.searchParams.set(key, value);
    });

    if (newParams == null) {
      return url.toString();
    }

    Object.entries(newParams).forEach(([key, value]) => {
      url.searchParams.set(key, value.toString());
    });

    return url.toString();
  }

  static getCurrentParamsAsJson() {
    const currentParams = new URLSearchParams(window.location.search);
    const paramsJson = {};

    currentParams.forEach((value, key) => {
      if (paramsJson.hasOwnProperty(key)) {
        if (Array.isArray(paramsJson[key])) {
          paramsJson[key].push(value);
        } else {
          paramsJson[key] = [paramsJson[key], value];
        }
      } else {
        paramsJson[key] = value;
      }
    });

    return paramsJson;
  }

  static async fetchProductVariantById(variantId, metafields) {
    // Nur echte Varianten-IDs abfragen (z. B. nicht serie_nr=2)
    if (!/^\d{8,}$/.test(String(variantId))) return null;
    // Bereits geladene Varianten für 30 Minuten pro Sitzung zwischenspeichern,
    // damit nicht jeder Konfigurator-Schritt alle Bauteile neu vom Server holt
    const cacheKey = "kxv4:" + variantId;
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey) || "null");
      if (cached && Date.now() - cached.t < 30 * 60 * 1000) return cached.v;
    } catch (e) {}
    const gid = "gid://shopify/ProductVariant/" + variantId;

    const query = `
    query getVariant($variantId: ID!) {
  node(id: $variantId) {
    ... on ProductVariant {
      id
      title
      price {
        amount
        currencyCode
      }
      deliveryTime: metafield(namespace: "custom", key: "delivery_time") {
        value
      }
      imageLayer: metafield(namespace: "custom", key: "image_layer") {
        value
      }
       background: metafield(namespace: "bed_layers", key: "background") {
        reference {
          ... on MediaImage {
            image {
              url
            }
          }
        }
      }
      headboard: metafield(namespace: "bed_layers", key: "headboard") {
        references(first: 10) {
          nodes {
            ... on MediaImage {
              image {
                url
              }
            }
          }
        }
      }
      box: metafield(namespace: "bed_layers", key: "box") {
        reference {
          ... on MediaImage {
            image {
              url
            }
          }
        }
      }
      feet: metafield(namespace: "bed_layers", key: "feet") {
        reference {
          ... on MediaImage {
            image {
              url
            }
          }
        }
      }
      matress: metafield(namespace: "bed_layers", key: "matress") {
        reference {
          ... on MediaImage {
            image {
              url
            }
          }
        }
      }
      topper: metafield(namespace: "bed_layers", key: "topper") {
        reference {
          ... on MediaImage {
            image {
              url
            }
          }
        }
      }
      product {
        title
      }
    }
  }
}

  `;

    const variables = {
      variantId: gid,
    };

    try {
      const response = await fetch("/api/2025-07/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            "1e9ef4c86d1872ff15865e4a5cf1f8f5",
        },
        body: JSON.stringify({
          query: query,
          variables: variables,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Fehler beim Abrufen der Variante:", errorData);
      }

      const result = await response.json();
      const variantData = result.data;

      if (variantData) {
        try {
          sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), v: variantData.node }));
        } catch (e) {}
        return variantData.node;
      } else {
        console.log("Variante nicht gefunden.");
        return null;
      }
    } catch (error) {
      console.error("Fehler beim Abrufen der Variante:", error);
      return null;
    }
  }

  static formatPrice(euros) {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    }).format(euros);
  }

  static updateDeliveryDate(days) {
    const today = new Date();

    const deliveryDate = new Date(today);
    deliveryDate.setDate(today.getDate() + days);

    const nextMonday = new Date(deliveryDate);
    const dayOfWeek = deliveryDate.getDay();

    const daysUntilNextMonday =
      dayOfWeek === 0 ? 1 : dayOfWeek === 1 ? 7 : 8 - dayOfWeek;

    nextMonday.setDate(deliveryDate.getDate() + daysUntilNextMonday);

    const nextFriday = new Date(nextMonday);
    nextFriday.setDate(nextMonday.getDate() + 4); // +4 Tage = Freitag

    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      return `${day}.${month}`;
    };

    const weekRange = `${formatDate(nextMonday)}. - ${formatDate(nextFriday)}.`;

    const deliveryElement = document.getElementById("delivery-time");
    if (deliveryElement) {
      deliveryElement.textContent = weekRange;
    }
  }

  static updatePrice(variantPrice, totalPrice) {
    const priceElement = document.getElementById("current-price");

    if (variantPrice === 0) {
      priceElement.textContent = this.formatPrice(totalPrice);
      return;
    }

    if ((totalPrice === 0 || !totalPrice) && priceElement) {
      priceElement.textContent = this.formatPrice(variantPrice / 100);
      return;
    }

    if (variantPrice && totalPrice && priceElement) {
      const sizePrice = Number(variantPrice / 100);
      priceElement.textContent = this.formatPrice(sizePrice + totalPrice);
    }
  }

  static calcTotalPrice(variants) {
    let totalPrice = 0;
    for (const variant of variants) {
      if (variant && variant.price) {
        totalPrice += Number(variant.price.amount);
      }
    }

    return totalPrice;
  }

  static async initPage() {
    const params = this.getCurrentParamsAsJson();

    const ids = [];
    Object.values(params).forEach((value) => {
      const splitIds = value.split(",");
      splitIds.forEach((id) => {
        const trimmedId = id.trim();
        if (trimmedId && !ids.includes(trimmedId)) {
          ids.push(trimmedId);
        }
      });
    });

    const promises = ids.map((id) => this.fetchProductVariantById(id));
    const variants = await Promise.all(promises);

    const idToVariantMap = {};
    ids.forEach((id, index) => {
      idToVariantMap[id] = variants[index];
    });

    const result = {};
    Object.entries(params).forEach(([key, idValue]) => {
      const firstId = idValue.split(",")[0].trim();
      result[key] = idToVariantMap[firstId];
    });

    if (result.serie) {
      GlobalGeneric.updateDeliveryDate(result.serie.deliveryTime.value);
      const urls = this.mergeBedLayers(...Object.values(result));
      await this.setMainImage(urls);
    }

    const totalPrice = this.calcTotalPrice(variants);

    return {
      result,
      totalPrice,
    };
  }

  static setParam(key, value) {
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    history.replaceState(null, "", url);
  }

  static removeParam(key) {
    const url = new URL(window.location.href);
    url.searchParams.delete(key);
    history.replaceState(null, "", url);
  }


  // Anzeigenamen bereinigen: interne Serien-Suffixe (" 2", " 3") entfernen und
  // Altnamen auf die Farbnamen aus der Stoff-Spezifikation mappen.
  static DISPLAY_NAME_MAP = { Antrahzit: "Anthrazit", Steel: "Dunkelgrau", Ocean: "Blau" };
  static cleanName(name) {
    if (!name) return name;
    let n = String(name).replace(/\s+[123]$/, "").trim();
    return GlobalGeneric.DISPLAY_NAME_MAP[n] || n;
  }

  // Zeichenreihenfolge = physischer Aufbau von hinten/unten nach vorne/oben:
  // Raum → Kopfteil → Füße → Box → Matratze (liegt auf der Box) → Topper (liegt auf der Matratze).
  // Die Box darf nicht zuletzt gezeichnet werden, sonst deckt sie die Unterkante der Matratze ab
  // und es entsteht ein dunkler Spalt.
  static BED_LAYER_INDEX = {
    background: 0,
    headboard: 1,
    feet: 2,
    box: 3,
    matress: 4,
    topper: 5,
  };

  static mergeBedLayers(...objects) {
    const mergedArray = new Array(
      Object.keys(this.BED_LAYER_INDEX).length,
    ).fill(null);

    console.log("Objects to merge:", objects);
    for (const obj of objects) {
      if (obj && typeof obj === "object") {
        for (const key in obj) {
          if (Object.prototype.hasOwnProperty.call(this.BED_LAYER_INDEX, key)) {
            const index = this.BED_LAYER_INDEX[key];

            let layerData = obj[key];
            if (layerData == null) {
              if (
                (obj.product.title === "feet" ||
                  obj.product.title === "serie") &&
                key === "feet"
              ) {
                console.error(
                  "Feet layer is null, setting to null explicitly.",
                );
                mergedArray[index] = null;
              }
              continue;
            }

            let url = this.getUrlsFromMetafield(layerData);

            if (key === "headboard") {
              let headboards = [];
              if (typeof url === "string") {
                try {
                  headboards = JSON.parse(url);
                } catch (e) {
                  console.error(
                    `Fehler beim Parsen des JSON-Strings für ${key}:`,
                    e,
                  );
                  continue;
                }
              }

              if (Array.isArray(url)) {
                headboards = url;
              }

              const existingHeadboard = mergedArray[this.BED_LAYER_INDEX.headboard];
              // Nur Farb-Varianten liefern eine Liste aller Kopfteile (>1) – daraus das gewählte Modell nehmen.
              // Die Kopfteil-Variante selbst liefert genau eine Ebene und wird unverändert übernommen.
              if (headboards.length > 1 && existingHeadboard) {
                const headboardNumber = existingHeadboard
                  .split("/")
                  .pop()
                  .split("_")[1];

                const match = headboards.find((h) => h.includes(`_${headboardNumber}_`));
                if (match) {
                  headboards = [match];
                } else if (/^K\d{3}$/.test(headboardNumber)) {
                  // Kopfteil fehlt in der Liste dieser Farbe: Datei nach Namensschema
                  // hdb_<Kopfteil>_<Stoff>_G180.png ableiten (alle Kombinationen liegen in Shopify Files)
                  headboards = [headboards[0].replace(/_K\d{3}_/, `_${headboardNumber}_`).split("?")[0]];
                }
              }
              url = headboards.length > 0 ? headboards[0] : null;
            }

            mergedArray[index] = url;
          }
        }
      }
    }
    return this.applyConfigLayers(mergedArray);
  }

  // Variant-IDs, die das Bettbild über den Aufbau hinaus verändern
  static KNG_MATTRESS_ID = "55286506193221"; // Königliche Matratze mit integriertem Topper
  static ELECTRIC_UPGRADE_ID = "54636145705285"; // Elektrisch verstellbar
  static FEET_LAYER_BY_VARIANT = {
    "55657173713221": "fc1500", // Metall Schwarz (Winkel)
    "54632196735301": "fc650", // Metall Schwarz Klassik
    "54632196702533": "fc450", // Metall Schwarz Filigran (Haarnadel)
    "54632196768069": "fc150", // Holz Massiv Schwarz
    "54632196800837": "fc250", // Holz Massiv Klassik (Eiche)
    "55646292279621": "fc1400", // Holz Eiche Skandi
    // 10-cm-Varianten: vorerst gleiches Render wie 15 cm (10-cm-Renders fehlen noch)
    "54632196604229": "fc150", // Holz Massiv Schwarz 10
    "54632196636997": "fc250", // Holz Massiv Klassik 10
    "54632196538693": "fc450", // Metall Schwarz Filigran 10
    "54632196571461": "fc650", // Metall Schwarz Klassik 10
  };
  static BEDBOX_IDS = ["54632144666949", "54632144699717"]; // Bettkasten frontal / seitlich
  // 10-cm-Füße: gleiche Render wie 15 cm, das Bett wird im Bild um 5 cm abgesenkt
  static FEET_10_IDS = ["54632196604229", "54632196636997", "54632196538693", "54632196571461", "54632196473157", "54632196505925"];
  static FEET_DROP = 0.019; // 5 cm ≈ 1,9 % der Bildkante (15-cm-Fuß ≈ 96 px bei 1600 px)

  // Kopfteil, Box, Matratze und Topper absenken; Hintergrund und Füße bleiben stehen,
  // so verdeckt die Box den oberen Teil der Füße
  static applyFeetDrop() {
    const w = document.getElementById("image-wrapper");
    if (!w) return;
    const fe = String(GlobalGeneric.getCurrentParamsAsJson().fe || "").split(",")[0];
    const drop = GlobalGeneric.FEET_10_IDS.includes(fe) ? GlobalGeneric.FEET_DROP * Math.max(w.clientWidth, w.clientHeight) : 0;
    w.querySelectorAll(".bed-layer").forEach((d) => {
      const z = Number(d.style.zIndex);
      const moves = z === GlobalGeneric.BED_LAYER_INDEX.headboard + 1 || z > GlobalGeneric.BED_LAYER_INDEX.feet + 1;
      d.style.transform = moves && drop ? `translateY(${drop.toFixed(1)}px)` : "";
    });
  }

  /**
   * Setzt Matratze, Topper und Füße passend zur Auswahl:
   * Königliche Matratze (weißer Doppeltuch-Bezug, Topper integriert) vs. Möbelstoff-Matratze + Topper,
   * zwei Matratzen (spl) vs. optisch durchgehend (mtc), elektrisch (elc) sowie das gewählte Fußmodell.
   * Die Ebenen liegen als WebP im Theme (window.koamiLayerAssets, Schlüssel = Dateiname ohne Endung).
   */
  static applyConfigLayers(layers) {
    const assets = window.koamiLayerAssets || {};
    const has = (k) => Object.prototype.hasOwnProperty.call(assets, k);
    const idx = this.BED_LAYER_INDEX;
    const params = this.getCurrentParamsAsJson();
    const list = (v) => String(v || "").split(",").map((s) => s.trim()).filter(Boolean);

    const royal = list(params.topperId).includes(this.KNG_MATTRESS_ID);
    const cont = list(params.opmat).length > 0 ? "mtc" : "spl";
    const elc = list(params.up).includes(this.ELECTRIC_UPGRADE_ID);

    // Stoffcode aus der Box- oder Matratzenebene lesen (z. B. SF5102)
    const src = [layers[idx.box], layers[idx.matress]].filter(Boolean).join(" ");
    const m = src.match(/_(S[SFGCBL]\d{4})/);
    const fabric = m ? m[1] : null;
    // Kunstleder-Matratzen heißen in den Renders SB55xx
    const mtrFabric = fabric && fabric.startsWith("SL") ? "SB" + fabric.slice(2) : fabric;

    if (royal) {
      const key = `kx_mtr_kng_g180_${cont}${elc ? "_elc" : ""}_500`;
      if (has(key)) {
        layers[idx.matress] = assets[key];
        layers[idx.topper] = null; // Topper ist in die Königliche Matratze integriert
      }
    } else if (mtrFabric && (cont === "mtc" || elc)) {
      const f = mtrFabric.toLowerCase();
      const candidates = [`kx_mtr_cov_${f}_g180_${cont}${elc ? "_elc" : ""}`];
      if (elc) candidates.push(`kx_mtr_cov_${f}_g180_${cont === "spl" ? "mtc" : "spl"}_elc`);
      const key = candidates.find(has);
      if (key) {
        layers[idx.matress] = assets[key];
        const usedCont = key.includes("_mtc") ? "mtc" : "spl";
        if (elc && has(`kx_tpr_g180_500_elc_${usedCont}`)) layers[idx.topper] = assets[`kx_tpr_g180_500_elc_${usedCont}`];
      }
    }

    const feetKey = this.FEET_LAYER_BY_VARIANT[list(params.fe)[0]];
    if (feetKey && has("kx_" + feetKey)) layers[idx.feet] = assets["kx_" + feetKey];

    return layers;
  }

  /**
   * Extrahiert die URL(s) aus einem Shopify MetaImage-Metafeld-Objekt oder einem URL-String.
   *
   * @param {object|string|null} metafieldData - Das Metafeld-Objekt oder der URL-String.
   * @returns {string|string[]|null} Eine einzelne URL (String), ein Array von URLs oder null.
   */
  static getUrlsFromMetafield(metafieldData) {
    if (!metafieldData) {
      return null;
    }

    if (typeof metafieldData === "string") {
      return metafieldData;
    }

    if (
      metafieldData.references &&
      Array.isArray(metafieldData.references.nodes)
    ) {
      const urls = metafieldData.references.nodes
        .map((node) => node?.image?.url)
        .filter((url) => url);

      return urls.length > 0 ? urls : null;
    }

    if (metafieldData.reference) {
      return metafieldData.reference.image?.url || null;
    }

    return null;
  }

  static async setMainImage(imageUrls) {
    const mainImageWrapper = document.getElementById("image-wrapper");
    if (!mainImageWrapper) {
      console.error("Element with id 'image-wrapper' not found.");
      return;
    }

    // Nur der zuletzt angeforderte Bildstand darf gesetzt werden (verhindert, dass
    // ein langsamer älterer Ladevorgang die neue Auswahl überschreibt)
    const requestId = (GlobalGeneric._imageRequestId = (GlobalGeneric._imageRequestId || 0) + 1);

    // Render-Ebenen sind 2000px-PNGs mit 6–8 MB: über das Shopify-CDN passend skaliert laden
    const targetWidth = Math.min(
      2000,
      Math.ceil(((mainImageWrapper.clientWidth || 1000) * (window.devicePixelRatio || 1)) / 200) * 200,
    );
    imageUrls = imageUrls.map((url) => {
      if (!url || typeof url !== "string" || !/cdn\.shopify\.com|\/cdn\/shop\//.test(url)) return url;
      const u = new URL(url, window.location.origin);
      u.searchParams.set("width", String(targetWidth));
      return u.toString();
    });

    // Alle Bilder vorladen
    const shown = new Set(
      Array.from(mainImageWrapper.querySelectorAll(".bed-layer")).map((d) => d.dataset.src || (d.style.backgroundImage.match(/url\(["']?(.*?)["']?\)/) || [])[1]),
    );
    const loadPromises = imageUrls.map((url) => {
      if (url && shown.has(url)) return Promise.resolve(null);
      if (!url) {
        console.warn("Leere URL, überspringe das Laden.");
        return Promise.resolve(null);
      }
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = url;
      });
    });

    try {
      await Promise.all(loadPromises);
      if (requestId !== GlobalGeneric._imageRequestId) return;
      // Für den nächsten Schritt merken, damit das Bett dort sofort sichtbar ist
      try {
        sessionStorage.setItem("kx_layers", JSON.stringify(imageUrls.filter(Boolean)));
      } catch (e) {}
      // Für den Warenkorb merken, welche Ebenen das aktuelle Bett bilden
      GlobalGeneric.lastLayerUrls = imageUrls
        .filter(Boolean)
        .map((u) => u.replace(/([?&])width=\d+/, "$1width=600"));

      // Nur geänderte Ebenen austauschen – Hintergrund und unveränderte Teile bleiben stehen
      const existing = Array.from(mainImageWrapper.querySelectorAll(".bed-layer"));
      const byZ = {};
      existing.forEach((d) => (byZ[d.style.zIndex] = d));
      const keep = new Set();
      for (let i = 0; i < imageUrls.length; i++) {
        const url = imageUrls[i];
        if (!url) continue;
        const z = String(i + 1);
        let div = byZ[z];
        if (div && div.dataset.src !== url && div.style.backgroundImage.indexOf(url) === -1) {
          const fresh = document.createElement("div");
          fresh.className = "bed-layer kx-layer-in";
          fresh.style.zIndex = z;
          fresh.style.backgroundImage = `url('${url}')`;
          fresh.dataset.src = url;
          div.replaceWith(fresh);
          div = fresh;
        } else if (!div) {
          div = document.createElement("div");
          div.className = "bed-layer kx-layer-in";
          div.style.zIndex = z;
          div.style.backgroundImage = `url('${url}')`;
          div.dataset.src = url;
          mainImageWrapper.appendChild(div);
        }
        keep.add(div);
      }
      mainImageWrapper.querySelectorAll(".bed-layer").forEach((d) => keep.has(d) || d.remove());
      GlobalGeneric.applyFeetDrop();
    } catch (error) {
      console.error("Fehler beim Laden der Bilder:", error);
    }
  }
}

/* ---- Info-Tooltips (ⓘ) für Konfigurator-Optionen ---- */
(function () {
  const TIPS = {
    "Signature": "Doppelter Tonnen-Taschenfederkern in Box und Matratze plus ca. 8 cm Topper – spürbar mehr Komfort als ein einfacher Boxspring-Aufbau.",
    "Prestige": "Unser Topmodell: die hochwertigste Ausstattung der koami Kollektion mit extra dickem Luxus-Topper (ca. 9 cm).",
    "Standard Box": "Klassische Boxspring-Box mit ca. 27 cm Höhe – für eine komfortable Einstiegshöhe.",
    "Schmale Box": "Die gleiche Box, nur rund 7 cm flacher (ca. 20 statt 27 cm). Das Bett wirkt dadurch leichter und moderner, die Liegehöhe sinkt entsprechend. Gleicher Federkern, gleicher Komfort.",
    "Bettkasten": "Box mit integriertem Stauraum. Öffnet dank Gasdruckfedern leicht – frontal oder seitlich. Wird auf Gleitern geliefert, daher keine Fußauswahl.",
    "Optisch durchgehende Box": "Ein durchgehender Bezug lässt die zwei Boxen wie aus einem Stück wirken.",
    "Königliche Matratze mit integriertem Topper": "Matratze im edlen Doppeltuch-Bezug mit fest integriertem Topper – nichts verrutscht, kein separates Auflegen.",
    "Matratze im Möbelstoff mit separatem Topper": "Matratze im gleichen Stoff wie Dein Bett, darauf ein separater Topper.",
    "Optisch durchgehende Matratze": "Zwei Matratzenkerne in einem durchgehenden Bezug – keine Ritze in der Mitte.",
    "Kaltschaum": "Atmungsaktiv und punktelastisch – ein stützendes, eher festes Liegegefühl.",
    "Visco-Schaum": "Passt sich langsam der Körperform an und entlastet Druckpunkte – eher weiches Liegegefühl.",
    "Latex": "Sehr elastisch und langlebig, federt schnell zurück – angenehm, wenn Du Dich nachts viel bewegst.",
    "H2": "Richtwert: weich – für Personen bis ca. 80 kg.",
    "H3": "Richtwert: mittel – für Personen von ca. 80 bis 100 kg.",
    "H4": "Richtwert: fest – für Personen ab ca. 100 kg.",
    "Elektrisch Verstellbar": "Kopf- und Fußteil per Fernbedienung stufenlos verstellbar – ideal zum Lesen und Fernsehen.",
    "Rückseite des Kopfteils mit Möbelstoff bezogen": "Auch die Rückseite des Kopfteils wird mit Deinem Stoff bezogen – sinnvoll, wenn das Bett frei im Raum steht.",
    "Samt": "Weicher, edler Flor mit leichtem Glanz.",
    "Cord": "Markante Rippenstruktur, weich und robust.",
    "Boucle": "Flauschige, lockige Struktur – sehr wohnlich.",
    "Feiner Stoff": "Glatt gewebter, pflegeleichter Möbelstoff.",
    "Grober Stoff": "Strukturierter Webstoff mit natürlicher Optik.",
    "Kunstleder": "Pflegeleicht und abwischbar.",
  };
  const SELECTOR = ".konfigurator .variant-title, .konfigurator #fabrics .item, .konfigurator label, .konfigurator .box-title, .konfigurator .variant-details > div:first-child";

  function baseText(el) {
    const clone = el.cloneNode(true);
    clone.querySelectorAll(".kx-tip, .kx-count").forEach((n) => n.remove());
    return GlobalGeneric.cleanName(clone.textContent.trim());
  }
  function decorate(root) {
    root.querySelectorAll(SELECTOR).forEach((el) => {
      if (el.querySelector(".kx-tip")) return;
      const tip = TIPS[baseText(el)];
      if (!tip) return;
      const b = document.createElement("span");
      b.className = "kx-tip";
      b.tabIndex = 0;
      b.setAttribute("role", "button");
      b.setAttribute("aria-label", "Info");
      b.innerHTML = '<span class="kx-tip__i">i</span><span class="kx-tip__box" role="tooltip"></span>';
      b.querySelector(".kx-tip__box").textContent = tip;
      b.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault();
        document.querySelectorAll(".kx-tip.is-open").forEach((o) => o !== b && o.classList.remove("is-open"));
        b.classList.toggle("is-open");
      });
      el.appendChild(b);
    });
  }
  document.addEventListener("click", () => document.querySelectorAll(".kx-tip.is-open").forEach((o) => o.classList.remove("is-open")));
  document.addEventListener("DOMContentLoaded", () => {
    const root = document.querySelector(".konfigurator") || document.body;
    decorate(root);
    new MutationObserver(() => decorate(root)).observe(root, { childList: true, subtree: true });
  });
})();

/* ---- Bemaßung (Maße-Button am Bett) und Kaufberatung (Tipp-Karten) ---- */
(function () {
  // Alle Maße ca.-Angaben nach Fey-Lieferantenunterlagen
  const HEADBOARD_HEIGHT = { celine: 105, elora: 105, florel: 124, lucel: 105, lumi: 127, maelis: 120, mirel: 130, solane: 114, thalia: 105 };
  const BOX_HEIGHT = { "54632144732485": 27, "54632144634181": 20, "54632144666949": 35, "54632144699717": 35 }; // Standard / Schmal / Bettkasten
  const FEET_10 = ["54632196604229", "54632196636997", "54632196538693", "54632196571461", "54632196473157", "54632196505925"];
  const MATTRESS = { royal: 25, fabric: 25 }; // ca. 25 cm laut Fey-Spezifikation Serie 2/3
  const TOPPER = { "54460662579525": 8, "54460662612293": 9 }; // Signature ca. 8 cm, Prestige ca. 9 cm

  const TIPS = {
    bsbc_serie_01: {
      title: "Signature oder Prestige?",
      html: "<p><b>Signature</b> ist unser Allrounder: doppelter Tonnen-Taschenfederkern in Box und Matratze – spürbar mehr Komfort als ein einfaches Boxspringbett.</p><p><b>Prestige</b> ist das Topmodell mit der hochwertigsten Ausstattung. Lohnt sich, wenn Du viel Zeit im Bett verbringst oder das Maximum willst.</p>",
    },
    bsbc_size_02: {
      title: "Welche Größe ist die richtige?",
      html: "<ul><li><b>Länge:</b> mindestens 20 cm mehr als Deine Körpergröße. Ab ca. 1,85 m lohnt sich 210 oder 220 cm.</li><li><b>Breite:</b> rechne pro Person mit mindestens 80–90 cm. Für Paare ist <b>180×200</b> der Klassiker, 200 cm gibt deutlich mehr Freiraum.</li><li><b>Mit Kindern oder Haustier:</b> Familienbetten mit 240 oder 280 cm.</li><li>Plane rund um das Bett ca. 60–70 cm Laufweg ein.</li></ul><div class=\"kx-calc kx-size\"><b>Größen-Rechner</b><div class=\"kx-calc__row\"><label>Körpergröße <input type=\"number\" min=\"120\" max=\"230\" placeholder=\"cm\" data-f=\"h\"></label><label>Personen <select data-f=\"p\"><option value=\"1\">1</option><option value=\"2\" selected>2</option></select></label></div><div class=\"kx-calc__row kx-calc__checks\"><label><input type=\"checkbox\" data-f=\"r\"> Unruhiger Schlaf</label><label><input type=\"checkbox\" data-f=\"k\"> Kind/Haustier schläft mit</label></div><p class=\"kx-calc__out\">Bei zwei Personen: Größe der größeren Person eingeben.</p></div>",
    },
    bsbc_headboard_03: {
      title: "Welches Kopfteil passt zu mir?",
      html: "<ul><li><b>Zum Anlehnen & Lesen:</b> hohe, weich gepolsterte Kopfteile wie Mirel, Lumi oder Florel.</li><li><b>Unter Dachschrägen oder Fenstern:</b> niedrigere Modelle wie Celine, Elora, Lucel oder Thalia.</li><li><b>Zeitlos & ruhig:</b> glatte Kopfteile (Celine, Thalia). <b>Wohnlich & klassisch:</b> Steppungen (Elora, Mirel, Maelis).</li></ul><p>Tipp: Unter „Maße“ am Bett siehst Du die Kopfteilhöhe.</p>",
    },
    bsbc_color_04: {
      title: "Welcher Stoff für welchen Alltag?",
      html: "<ul><li><b>Mit Kindern oder Haustieren:</b> Feiner oder Grober Stoff – robust und pflegeleicht. Kunstleder ist abwischbar.</li><li><b>Besonders gemütlich:</b> Bouclé und Samt.</li><li><b>Markant & robust:</b> Cord.</li><li>Helle Farben wirken luftig, dunkle Töne verzeihen mehr.</li></ul><p>Unsicher? <a href=\"/products/stoffmuster\">Kostenlose Stoffmuster bestellen</a>.</p>",
    },
    bsbc_box_05: {
      title: "Standard oder schmale Box?",
      html: "<p>Die <b>Standard-Box</b> (ca. 27 cm) ergibt eine bequeme Einstiegshöhe – ideal, wenn Du Dich gern auf die Bettkante setzt oder Knie und Rücken schonen möchtest.</p><p>Die <b>schmale Box</b> (ca. 20 cm) macht das Bett rund 7 cm niedriger und optisch leichter – schön in modernen, niedrigen Einrichtungen.</p><p>Der <b>Bettkasten</b> bietet Stauraum unter der Liegefläche und öffnet dank Gasdruckfedern leicht – frontal oder seitlich. Er steht auf Gleitern, Füße entfallen.</p><p>Faustregel: Die Liegehöhe sollte ungefähr Deiner Kniehöhe entsprechen.</p>",
    },
    bsbc_feet_06: {
      title: "Welche Füße?",
      html: "<ul><li><b>Holz</b> (Eiche, schwarz) wirkt warm und natürlich – passt zu Scandi- und Landhaus-Stil.</li><li><b>Metall</b> (Winkel, schlank, Haarnadel) wirkt modern und leicht.</li><li>Du hast die Wahl zwischen <b>10 cm</b> (inklusive) und <b>15 cm</b> (+15 €). Mit 15 cm passen die meisten Saugroboter unter das Bett, und die Einstiegshöhe steigt um 5 cm.</li></ul>",
    },
    bsbc_topper_07: {
      title: "Welcher Topper passt zu Dir?",
      html: "<ul><li><b>Kaltschaum:</b> stützend und atmungsaktiv – gut für Rückenschläfer und alle, die schnell warm werden.</li><li><b>Visco-Schaum:</b> passt sich langsam an und entlastet Schulter und Hüfte – beliebt bei Seitenschläfern.</li><li><b>Latex:</b> sehr elastisch und langlebig – ideal, wenn Du Dich nachts oft drehst.</li></ul>",
    },
    bsbc_matress_08: {
      title: "Welche Matratze und welcher Härtegrad?",
      html: "<p><b>Königliche Matratze:</b> Topper fest integriert, nichts verrutscht. <b>Möbelstoff-Matratze:</b> im Stoff Deines Bettes, mit separatem Topper.</p><p>Beide Seiten bekommen ihren eigenen Härtegrad – perfekt für Paare mit unterschiedlichem Gewicht.</p><div class=\"kx-calc\"><b>Härtegrad-Rechner</b><div class=\"kx-calc__row\"><label>Links <input type=\"number\" min=\"30\" max=\"200\" placeholder=\"kg\" data-side=\"l\"></label><label>Rechts <input type=\"number\" min=\"30\" max=\"200\" placeholder=\"kg\" data-side=\"r\"></label></div><p class=\"kx-calc__out\">Gib Euer Gewicht ein – wir empfehlen den passenden Härtegrad.</p></div>",
    },
    bsbc_upgrades_09: {
      title: "Lohnt sich elektrisch?",
      html: "<ul><li><b>Elektrisch verstellbar:</b> ideal, wenn Du im Bett liest, fernsiehst oder mit erhöhtem Oberkörper besser schläfst. Jede Seite lässt sich separat einstellen.</li><li><b>Rückseite bezogen:</b> sinnvoll, wenn das Bett frei im Raum steht und man das Kopfteil von hinten sieht.</li></ul>",
    },
  };

  function step() {
    const m = location.pathname.match(/bsbc_[a-z]+_\d+/);
    return m ? m[0] : null;
  }

  function addTip() {
    const tip = TIPS[step()];
    const col = document.querySelector(".konfigurator .variants-column-top");
    if (!tip || !col || col.querySelector(".kx-advice")) return;
    const box = document.createElement("details");
    box.className = "kx-advice";
    box.innerHTML = `<summary><span class="kx-advice__icon">💡</span>${tip.title}</summary><div class="kx-advice__body">${tip.html}</div>`;
    const anchor = col.querySelector(".progress-container, #progressFill")?.closest("div");
    if (anchor && anchor.parentElement === col) anchor.after(box);
    else col.prepend(box);
    const size = box.querySelector(".kx-size");
    if (size) {
      const out = size.querySelector(".kx-calc__out");
      const val = (f) => size.querySelector(`[data-f="${f}"]`);
      const LENGTHS = [190, 200, 210, 220];
      const WIDTHS = [90, 100, 120, 140, 160, 180, 200, 240, 280];
      size.addEventListener("input", () => {
        const h = +val("h").value;
        if (!h || h < 120) return (out.innerHTML = "Bei zwei Personen: Größe der größeren Person eingeben.");
        const persons = +val("p").value;
        // Schlafforschung/Liegeberatung: Liegefläche ≈ Körpergröße + 20–25 cm, pro Erwachsenem ≥ 90–100 cm Breite
        const length = LENGTHS.find((l) => l >= h + 20) || 220;
        let w = persons === 2 ? 180 : 100;
        if (val("r").checked) w += persons === 2 ? 20 : 10;
        if (val("k").checked) w += 40;
        const width = WIDTHS.find((x) => x >= w) || 280;
        const tight = h + 20 > 220;
        out.innerHTML = `Unsere Empfehlung: <b>${width} × ${length} cm</b><br><small>Liegelänge = Körpergröße + mind. 20 cm (Kopf- und Fußfreiraum)` +
          `, Breite ${persons === 2 ? "je Person mind. 90 cm" : "mind. 90–100 cm"}${val("r").checked ? ", +10 cm pro Person bei unruhigem Schlaf" : ""}${val("k").checked ? ", +40 cm für Kind/Haustier" : ""}.` +
          `${tight ? " Du bist sehr groß – 220 cm ist unsere längste Größe, sprich uns gern an." : ""}</small>`;
        const card = (group, cm) => [...document.querySelectorAll(`#${group} .variant-card-sm`)].find((c) => parseInt(c.textContent) === cm);
        document.querySelectorAll(".kx-size-rec").forEach((el) => el.classList.remove("kx-size-rec"));
        const lc = card("length-items", length), wc = card("widths-items", width);
        [lc, wc].forEach((c) => c && c.classList.add("kx-size-rec"));
        if (lc && wc) {
          const btn = document.createElement("button");
          btn.type = "button";
          btn.className = "kx-size-apply";
          btn.textContent = "Empfehlung übernehmen";
          btn.onclick = () => {
            card("length-items", length)?.click();
            setTimeout(() => {
              const w2 = card("widths-items", width);
              w2?.click();
              [card("length-items", length), w2].forEach((c) => c && c.classList.add("kx-size-rec"));
            }, 150);
          };
          out.appendChild(btn);
        }
      });
    }
    const calc = box.querySelector(".kx-calc:not(.kx-size)");
    if (calc) {
      const out = calc.querySelector(".kx-calc__out");
      const rec = (kg) => (kg < 80 ? "H2 (weich)" : kg <= 100 ? "H3 (mittel)" : "H4 (fest)");
      calc.addEventListener("input", () => {
        const l = +calc.querySelector('[data-side="l"]').value;
        const r = +calc.querySelector('[data-side="r"]').value;
        const parts = [];
        if (l) parts.push(`Links: <b>${rec(l)}</b>`);
        if (r) parts.push(`Rechts: <b>${rec(r)}</b>`);
        out.innerHTML = parts.length ? parts.join(" · ") + "<br><small>Richtwert – bei Rückenbeschwerden eher etwas fester wählen.</small>" : "Gib Euer Gewicht ein – wir empfehlen den passenden Härtegrad.";
      });
    }
  }

  async function dims() {
    const p = GlobalGeneric.getCurrentParamsAsJson();
    const first = (v) => String(v || "").split(",")[0];
    const [size, he] = await Promise.all([
      p.size ? GlobalGeneric.fetchProductVariantById(first(p.size)) : null,
      p.he ? GlobalGeneric.fetchProductVariantById(first(p.he)) : null,
    ]);
    let length = null, width = null;
    if (size && size.title) {
      const m = size.title.match(/(\d+)\s*\/\s*(\d+)/);
      if (m) { length = +m[1]; width = +m[2]; }
    }
    const royal = first(p.topperId) === GlobalGeneric.KNG_MATTRESS_ID;
    const boxH = BOX_HEIGHT[first(p.box)] || 27;
    const bedbox = GlobalGeneric.BEDBOX_IDS.includes(first(p.box));
    const FEET_HEIGHT = bedbox ? 3 : FEET_10.includes(first(p.fe)) ? 10 : 15;
    const topper = TOPPER[first(p.serie)] || 8;
    const lieg = FEET_HEIGHT + boxH + (royal ? MATTRESS.royal : MATTRESS.fabric + topper);
    const hbName = he && he.title ? GlobalGeneric.cleanName(he.title).toLowerCase() : null;
    const hbH = hbName ? HEADBOARD_HEIGHT[hbName] : null;
    return { length, width, lieg, hbH, boxH, feetH: FEET_HEIGHT, bedbox };
  }

  // Maßlinien direkt am Bett (Koordinaten im 1600×1600-Render, per viewBox wie background-size: cover)
  const GEO = {
    near: { x: 500, top: 973, box: 1327, floor: 1427 },   // vordere Ecke am Fußende
    right: { x: 1504, top: 900, box: 1207, floor: 1307 }, // rechte Ecke am Fußende
    back: { x: 113, box: 1147 },                           // hintere Ecke Richtung Kopfteil
    hbX: 52, hbFloor: 1213,
    posY: 0.72, // muss zu background-position der .bed-layer passen (konfigurator.css)
    hbTop: { K501: 671, K502: 672, K503: 571, K504: 672, K505: 558, K506: 594, K507: 539, K508: 625, K509: 671 },
  };

  // sichtbarer Ausschnitt des 1600er-Renders bei background-size: cover und Position 50 % / posY
  function fitBox(wrap) {
    const W = wrap.clientWidth || 1, H = wrap.clientHeight || 1;
    const sc = Math.max(W, H) / 1600, vw = W / sc, vh = H / sc;
    return `${((1600 - vw) * 0.5).toFixed(1)} ${((1600 - vh) * GEO.posY).toFixed(1)} ${vw.toFixed(1)} ${vh.toFixed(1)}`;
  }
  window.addEventListener("resize", () => {
    const w = document.getElementById("image-wrapper");
    const svg = w && w.querySelector(".kx-dimlines");
    if (svg) svg.setAttribute("viewBox", fitBox(w));
  });

  function currentHeadboardCode() {
    for (const d of document.querySelectorAll("#image-wrapper .bed-layer")) {
      const m = (d.dataset.src || d.style.backgroundImage || "").match(/hdb_(K\d{3})_/i);
      if (m) return m[1].toUpperCase();
    }
    return "K501";
  }

  function pill(x, y, text, angle = 0) {
    const w = 18 * text.length + 36;
    return `<g transform="translate(${x} ${y}) rotate(${angle})"><rect x="${-w / 2}" y="-26" width="${w}" height="52" rx="26" fill="#fff" fill-opacity=".94"/><text x="0" y="11" text-anchor="middle" font-size="31" font-weight="600" fill="#1f2326">${text}</text></g>`;
  }

  function dimLine(x1, y1, x2, y2) {
    // Maßlinie mit Endstrichen senkrecht zur Linie
    const dx = x2 - x1, dy = y2 - y1, len = Math.hypot(dx, dy) || 1;
    const nx = (-dy / len) * 14, ny = (dx / len) * 14;
    return `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}"/>` +
      `<line x1="${x1 - nx}" y1="${y1 - ny}" x2="${x1 + nx}" y2="${y1 + ny}"/>` +
      `<line x1="${x2 - nx}" y1="${y2 - ny}" x2="${x2 + nx}" y2="${y2 + ny}"/>`;
  }

  async function renderDims() {
    const wrap = document.getElementById("image-wrapper");
    if (!wrap) return;
    const d = await dims();
    const p = GlobalGeneric.getCurrentParamsAsJson();
    const first = (v) => String(v || "").split(",")[0];
    const drop = GlobalGeneric.FEET_10_IDS.includes(first(p.fe)) ? GlobalGeneric.FEET_DROP * 1600 : 0;
    const royal = first(p.topperId) === GlobalGeneric.KNG_MATTRESS_ID ? 32 : 0;
    const G = GEO, N = G.near, R = G.right, B = G.back;
    const hbTop = (G.hbTop[currentHeadboardCode()] || 671) + drop;
    // Breite: parallel zur Fußende-Unterkante, unterhalb der Füße
    const wy1 = N.box + drop + 48, wy2 = R.box + drop + 48;
    // Länge: parallel zur Seiten-Unterkante, nach außen versetzt
    const ox = -42, oy = 74;
    const lx1 = N.x + ox, ly1 = N.box + drop + oy, lx2 = B.x + ox, ly2 = B.box + drop + oy;
    const hx = 1556, hTop = R.top + drop + royal;
    const ext = (x1, y1, x2, y2) => `<line class="ext" x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}"/>`;
    const svgEl = `<svg class="kx-dimlines" viewBox="${fitBox(wrap)}" preserveAspectRatio="none" aria-hidden="true">
      <g stroke="#1f2326" stroke-width="3.5" fill="none">
        ${ext(N.x, N.box + drop + 6, N.x, wy1 + 14)}${ext(R.x, R.box + drop + 6, R.x, wy2 + 14)}
        ${dimLine(N.x, wy1, R.x, wy2)}
        ${ext(N.x - 8, N.box + drop + 18, lx1 - 6, ly1 + 12)}${ext(B.x - 8, B.box + drop + 18, lx2 - 6, ly2 + 12)}
        ${dimLine(lx1, ly1, lx2, ly2)}
        ${ext(R.x + 10, hTop, hx + 16, hTop)}${ext(R.x + 10, R.floor, hx + 16, R.floor)}
        ${dimLine(hx, hTop, hx, R.floor)}
        ${d.hbH ? ext(G.hbX + 34, hbTop, G.hbX - 16, hbTop) + ext(G.hbX + 34, G.hbFloor, G.hbX - 16, G.hbFloor) + dimLine(G.hbX, hbTop, G.hbX, G.hbFloor) : ""}
      </g>
      ${d.width ? pill((N.x + R.x) / 2, (wy1 + wy2) / 2, `${d.width} cm`, (Math.atan2(wy2 - wy1, R.x - N.x) * 180) / Math.PI) : ""}
      ${d.length ? pill(lx1 + (lx2 - lx1) * 0.62, ly1 + (ly2 - ly1) * 0.62, `${d.length} cm`, (Math.atan2(ly1 - ly2, lx1 - lx2) * 180) / Math.PI) : ""}
      ${pill(hx - 70, (hTop + R.floor) / 2, `${d.lieg} cm`)}
      ${d.hbH ? pill(G.hbX + 70, (hbTop + G.hbFloor) / 2, `${d.hbH} cm`) : ""}
    </svg>`;
    let layer = wrap.querySelector(".kx-dimlayer");
    if (!layer) {
      layer = document.createElement("div");
      layer.className = "kx-dimlayer";
      wrap.appendChild(layer);
    }
    layer.innerHTML = svgEl + `<p class="kx-dimlayer__note">Liegehöhe ${d.lieg} cm · ${d.bedbox ? "Bettkasten" : "Box"} ${d.boxH} cm · ${d.bedbox ? "auf Gleitern" : `Füße ${d.feetH} cm`} · alle Angaben ca.</p>`;
  }

  function addDims() {
    const col = document.querySelector(".konfigurator .image-column");
    if (!col || col.querySelector(".kx-dims-btn")) return;
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "kx-dims-btn";
    btn.innerHTML = "📐 Maße";
    // Werkzeugleiste unter dem Bett: Entwurf teilen · Maße · Gratis Stoffmuster
    const tools = document.createElement("div");
    tools.className = "kx-tools";
    const share = document.createElement("button");
    share.type = "button";
    share.className = "kx-tool";
    share.innerHTML = "🔗 Entwurf teilen";
    share.onclick = async () => {
      const url = location.href;
      try {
        if (navigator.share && matchMedia("(pointer: coarse)").matches) {
          await navigator.share({ title: "Mein koami Boxspringbett", url });
          return;
        }
        await navigator.clipboard.writeText(url);
        share.innerHTML = "✓ Link kopiert";
      } catch (e) {
        window.prompt("Link zu Deinem Entwurf:", url);
      }
      setTimeout(() => (share.innerHTML = "🔗 Entwurf teilen"), 2200);
    };
    const samples = document.createElement("a");
    samples.className = "kx-tool";
    samples.href = "/products/stoffmuster";
    samples.target = "_blank";
    samples.rel = "noopener";
    samples.innerHTML = "✂️ Gratis Stoffmuster";
    btn.classList.add("kx-tool");
    tools.append(share, btn, samples);
    col.append(tools);
    let last = 0;
    btn.onclick = async () => {
      if (Date.now() - last < 400) return; // Doppelklick-Schutz
      last = Date.now();
      const on = !document.body.classList.contains("kx-dims-on");
      document.body.classList.toggle("kx-dims-on", on);
      btn.classList.toggle("is-active", on);
      if (on) await renderDims();
    };
    // Bei Auswahländerung (setParam): Maße aktualisieren und – wenn sich Matratze,
    // Upgrades oder Füße ändern – das Bettbild sofort neu zusammensetzen
    const orig = GlobalGeneric.setParam.bind(GlobalGeneric);
    let redraw;
    GlobalGeneric.setParam = function (k, v) {
      orig(k, v);
      if (document.body.classList.contains("kx-dims-on")) setTimeout(renderDims, 120);
      if (["topperId", "opmat", "up", "fe", "box"].includes(k)) {
        clearTimeout(redraw);
        redraw = setTimeout(() => GlobalGeneric.initPage().catch(() => {}), 60);
      }
    };
    const origRemove = GlobalGeneric.removeParam.bind(GlobalGeneric);
    GlobalGeneric.removeParam = function (k) {
      origRemove(k);
      if (["opmat", "up"].includes(k)) {
        clearTimeout(redraw);
        redraw = setTimeout(() => GlobalGeneric.initPage().catch(() => {}), 60);
      }
    };
  }

  function feetNotes() {
    if (step() !== "bsbc_feet_06") return;
    const col = document.querySelector(".konfigurator .variants-column-top");
    if (!col) return;
    const p = GlobalGeneric.getCurrentParamsAsJson();
    const box = String(p.box || "").split(",")[0];
    const note = document.createElement("p");
    note.className = "kx-note";
    note.innerHTML = GlobalGeneric.BEDBOX_IDS.includes(box)
      ? "<b>Hinweis:</b> Mit Bettkasten steht Dein Bett auf Gleitern – Füße werden nicht montiert. Wähle einfach die 10-cm-Variante ohne Aufpreis."
      : "Tipp: Mit 15 cm passen die meisten Saugroboter unter das Bett – die Einstiegshöhe steigt um 5 cm.";
    col.appendChild(note);
  }

  window.addEventListener("resize", () => GlobalGeneric.applyFeetDrop());
  function pageInit() {
    if (!document.querySelector(".konfigurator")) return;
    GlobalGeneric.applyFeetDrop();
    addTip();
    addDims();
    feetNotes();
    if (document.body.classList.contains("kx-dims-on")) setTimeout(renderDims, 200);
  }
  document.addEventListener("DOMContentLoaded", pageInit);
  document.addEventListener("kx:page", pageInit);
})();


/* ---- Weiche Navigation: nur die rechte Spalte wechselt, das Bett bleibt stehen ----
   Statt jeden Schritt als neue Seite zu laden, wird die Zielseite im Hintergrund geholt.
   Ausgetauscht wird alles außer der Bildspalte; die Skripte des neuen Schritts laufen
   danach wie beim normalen Seitenaufruf. Bei Fehlern greift die klassische Navigation. */
(function () {
  const STEP = /\/pages\/bsbc_[a-z]+_\d+/;
  let busy = false;

  function isStep(url) {
    try {
      const u = new URL(url, location.href);
      return u.origin === location.origin && STEP.test(u.pathname);
    } catch (e) {
      return false;
    }
  }

  // Kinder von live durch die von next ersetzen, das Element keepSel aber unverändert lassen
  function morph(live, next, keepSel) {
    const keepLive = live.querySelector(":scope > " + keepSel);
    const keepNext = next.querySelector(":scope > " + keepSel);
    if (!keepLive || !keepNext) throw new Error("Struktur weicht ab: " + keepSel);
    const kids = [...next.childNodes];
    const idx = kids.indexOf(keepNext);
    [...live.childNodes].forEach((n) => n !== keepLive && n.remove());
    kids.slice(0, idx).forEach((n) => live.insertBefore(n, keepLive));
    kids.slice(idx + 1).forEach((n) => live.appendChild(n));
    return { live: keepLive, next: keepNext };
  }

  function loadedSrc(src) {
    const want = new URL(src, location.href).href;
    return [...document.scripts].some((s) => s.src && s.src === want && !s.dataset.kxPending);
  }

  async function runScripts(root) {
    const scripts = [...root.querySelectorAll("script")].filter(
      (s) => !s.closest(".image-column") && (!s.type || s.type === "text/javascript" || s.type === "module"),
    );
    const origAdd = document.addEventListener;
    // DOMContentLoaded ist längst vorbei: Handler des neuen Schritts sofort ausführen
    document.addEventListener = function (type, fn, opts) {
      if (type === "DOMContentLoaded") return void setTimeout(() => fn.call(document, new Event(type)), 0);
      return origAdd.call(this, type, fn, opts);
    };
    try {
      for (const old of scripts) {
        if (old.src) {
          if (loadedSrc(old.src)) continue;
          await new Promise((res) => {
            const s = document.createElement("script");
            s.src = old.src;
            s.onload = s.onerror = res;
            old.replaceWith(s);
          });
        } else {
          const s = document.createElement("script");
          s.textContent = old.textContent;
          old.replaceWith(s);
        }
      }
    } finally {
      setTimeout(() => (document.addEventListener = origAdd), 0);
    }
  }

  async function swap(url, push) {
    const res = await fetch(url, { credentials: "same-origin", headers: { Accept: "text/html" } });
    if (!res.ok) throw new Error("HTTP " + res.status);
    const doc = new DOMParser().parseFromString(await res.text(), "text/html");
    const liveKonf = document.querySelector(".konfigurator");
    const nextKonf = doc.querySelector(".konfigurator");
    const liveSec = liveKonf && liveKonf.closest(".shopify-section");
    const nextSec = nextKonf && nextKonf.closest(".shopify-section");
    if (!liveSec || !nextSec || !doc.querySelector("#image-wrapper")) throw new Error("kein Konfigurator-Schritt");

    const column = document.querySelector(".konfigurator .variants-column");
    if (column) column.classList.add("kx-leaving");
    if (push) history.pushState({ kx: 1 }, "", url);
    document.title = doc.title;

    // Abschnitt für Abschnitt tauschen, die Bildspalte (Bett, Werkzeugleiste) bleibt erhalten
    morph(liveSec, nextSec, ".konfigurator");
    const k = morph(liveKonf, nextKonf, ".product-container");
    morph(k.live, k.next, ".image-column");

    await runScripts(liveSec);
    const col = document.querySelector(".konfigurator .variants-column");
    if (col) {
      col.classList.add("kx-entering");
      col.scrollTop = 0;
      requestAnimationFrame(() => requestAnimationFrame(() => col.classList.remove("kx-entering")));
    }
    if (window.matchMedia("(max-width: 989px)").matches) {
      const top = document.querySelector(".konfigurator .variants-column");
      if (top) top.scrollIntoView({ block: "start" });
    }
    setTimeout(() => document.dispatchEvent(new Event("kx:page")), 50);
  }

  GlobalGeneric.go = async function (url, push = true) {
    if (!isStep(url) || busy || !window.fetch || !window.DOMParser) {
      location.href = url;
      return;
    }
    busy = true;
    try {
      await swap(url, push);
    } catch (e) {
      console.warn("Weiche Navigation fehlgeschlagen, lade Seite neu:", e);
      location.href = url;
    } finally {
      busy = false;
    }
  };

  // Links innerhalb des Konfigurators abfangen
  document.addEventListener("click", (e) => {
    const a = e.target.closest && e.target.closest(".konfigurator a[href]");
    if (!a || a.target === "_blank" || e.metaKey || e.ctrlKey || e.shiftKey || !isStep(a.href)) return;
    e.preventDefault();
    GlobalGeneric.go(a.href);
  });

  window.addEventListener("popstate", () => {
    if (isStep(location.href) && document.querySelector(".konfigurator")) GlobalGeneric.go(location.href, false);
  });
})();
